import React from 'react';
import BorrowingHeader from '../../shared/BorrowingHeader';

export default function RecentlyReturnedTitle() {
  return (
    <BorrowingHeader
      headingKey="section_title_recently_returned"
      helpLinkPage="040settings/005privacy-settings" />
  );
}



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedTitle/RecentlyReturnedTitle.jsx